/**
 * This file is the entrypoint of node builds.
 * The code executes when loaded in a node.
 */
import { verifyPassURI, verifyPassURIOffline, DID_DOCUMENTS, TRUSTED_ISSUERS } from "./main";
export { verifyPassURI, verifyPassURIOffline, DID_DOCUMENTS, TRUSTED_ISSUERS };
